export function applyTheme(theme: 'light' | 'dark'): void {
    document.documentElement.setAttribute('data-bs-theme', theme);
    localStorage.setItem('pdf-studio-theme', theme);
}

export function initTheme(): void {
    applyTheme(
        (localStorage.getItem('pdf-studio-theme') as 'light' | 'dark' | null) ??
            (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'),
    );
}

export function toggleTheme(): void {
    applyTheme(document.documentElement.getAttribute('data-bs-theme') === 'dark' ? 'light' : 'dark');
}
